import { render, staticRenderFns } from "./AlarmContent.vue?vue&type=template&id=c0501878&scoped=true"
import script from "./AlarmContent.vue?vue&type=script&lang=js"
export * from "./AlarmContent.vue?vue&type=script&lang=js"
import style0 from "./AlarmContent.vue?vue&type=style&index=0&id=c0501878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0501878",
  null
  
)

export default component.exports